import {IGlobalConfig} from "../../../../App";
import React, {FormEvent, useRef, useState} from "react";
import QRCode from 'react-qr-code';
import VscServerClient, {useVscServerClient} from "../../../../kova/vscServerClient";


const AdminConfiguratorStationRow: React.FC<{serverUri:string, salesCenterId:string, stationId: string}> = ({serverUri, salesCenterId, stationId}) => {

    return <tr className={"station"}>

        <td><input type={'checkbox'} data-station={stationId} /></td>
        <td>{stationId}</td>
        <td><a href={serverUri + `station/${stationId}/vsc_config.json`} download={"vsc_config.json"}>vsc_config.json</a></td>
    </tr>

}
export interface IMobileConfigurationRequest {
    stations:string[];
    includeCertificate:boolean;
}
async function getMobileConfigLink(vscServerClient: VscServerClient, stations: string[], includeCertificate: boolean) {

    const req: IMobileConfigurationRequest = {
        stations,
        includeCertificate
    };
    const mobileconfigLink = await vscServerClient.post("mobileconfig_link", JSON.stringify(req), { headers: { "Content-Type": "application/json"}});
    if (!mobileconfigLink.ok) {
        return null;
    }
    const mobileConfigLinkJson = await mobileconfigLink.json() as IMobileConfigResponse;
    return mobileConfigLinkJson;


}
interface IMobileConfigResponse {
    link: string;
    expires: string;
}
const MobileConfig: React.FC<{mobileConfigResponse:IMobileConfigResponse}> = ({mobileConfigResponse}) => {

    return <div>

       <p> Download: <a href={mobileConfigResponse.link} download={"vsc.mobileconfig"}>vsc.mobileconfig</a>
       </p>
        <QRCode value={mobileConfigResponse.link} />
    </div>
}
const AdminConfigurator: React.FC<{config: IGlobalConfig, serverUri:string, salesCenterId: string}> = (props) => {

    const { config, serverUri, salesCenterId } = props;
    const [isGenerating, setIsGenerating] = useState(false);
    const [mobileConfigLink, setMobileConfigLink] = useState<IMobileConfigResponse|null>(null);

    const vscServerClient = useVscServerClient();
    const generateMobileConfig = (ev: React.MouseEvent<HTMLButtonElement>) => {
        setIsGenerating(true);
        const form = ev.currentTarget.form!;
        const allSelected = form.querySelectorAll(".station input:checked");
        const selectedStations: string[] = [];
        for (const el of Array.from(allSelected)) {
            const elInput = el as HTMLInputElement;
            selectedStations.push(elInput.dataset.station!);
        }

        const certificateInput = form.querySelector<HTMLInputElement>('.certificate');
        const includeCertificate = certificateInput!.checked;

        if (vscServerClient === null) {
            console.error('VscServerClient not initialized');
            return;

        }
        getMobileConfigLink(vscServerClient, selectedStations, includeCertificate).then(link => {
            setIsGenerating(false);
            setMobileConfigLink(link);
        });



        ev.preventDefault();
        return false;


    }
    return <main>
        <h1>Configurator</h1>
        <form>
        <section className={"stations"}>
        <table>
            <thead>
            <tr>
                <th colSpan={3}>Stations</th>
            </tr>
            </thead>
            <tbody>
        { config.stationIds.map(stationId => <AdminConfiguratorStationRow key={stationId} serverUri={serverUri} salesCenterId={salesCenterId} stationId={stationId} />) }
            </tbody>
        </table>
        </section>

        <h3>iPad/iPhone configurator</h3>
        <p>Generate configuration profile for iOS devices that enables access to the Unreal visualizers at the sales center.
        </p>
        <p>Select the stations from the list above, optionally exclude the certificate file from the configuration profile and click the Generate button below.</p>
        <p><label><input type={"checkbox"} className={"certificate"} defaultChecked={true} /> Include certificate</label></p>
        <button onClick={generateMobileConfig} disabled={isGenerating}>Generate iOS configuration</button>
            { mobileConfigLink && <section>
                <h3>Generation successful! </h3>
                <p>Click the link below to download the configuration profile. Alternatively, you can scan the QR code to install it directly on iOS devices.</p>

                <MobileConfig mobileConfigResponse={mobileConfigLink} />
            </section>}
        </form>
    </main>

}
export default AdminConfigurator;